import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { YoutubeSourcePreviewItem, YoutubeSourceResponse, YoutubeSourceService } from '../../../services/youtube-source.service';

interface DialogData {
	source: YoutubeSourceResponse;
}

@Component({
	selector: 'app-youtube-source-preview-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatTableModule, TranslateModule],
	templateUrl: './youtube-source-preview-dialog.component.html',
	styleUrl: './youtube-source-preview-dialog.component.scss',
})
export class YoutubeSourcePreviewDialogComponent implements OnInit {
	loading = true;
	totalMatching = 0;
	displayedColumns: string[] = ['TITLE', 'DATE', 'SUBTITLES', 'STATUS'];
	dataSource: MatTableDataSource<YoutubeSourcePreviewItem> = new MatTableDataSource<YoutubeSourcePreviewItem>();

	constructor(
		private dialogRef: MatDialogRef<YoutubeSourcePreviewDialogComponent>,
		private apiYoutubeSource: YoutubeSourceService,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {}

	ngOnInit(): void {
		this.apiYoutubeSource
			.previewSource(this.data.source.id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.dataSource.data = response.items || [];
					this.totalMatching = response.totalMatching;
					this.loading = false;
				},
				error: () => {
					this.loading = false;
				},
			});
	}

	get shownCount(): number {
		return this.dataSource.data.length;
	}

	close(): void {
		this.dialogRef.close();
	}
}
